<template>
  <div class="painel-produtos">
    <div v-show="carregandoDados.status" class="d-flex align-items-center mb-3">
      <b-spinner v-show="carregandoDados.status" class="mr-2" variant="danger"></b-spinner>
      <span class="avisoDanger">{{ carregandoDados.mensagem }}</span>
    </div>

    <h4 class="mb-1">Produtos do Ecossistema</h4>
    <p class="text-muted">
      Selecione os produtos que estarão habilitados para este escritório.
      Produtos ativos terão suas funcionalidades liberadas conforme permissões do usuário.
    </p>

    <!-- Sem rodapé próprio: salvar/voltar são os botões da edição do escritório (Salvar salva os
         dados do escritório E estas configurações na mesma ação). -->
    <AcordeaoCategoriaProduto
      v-for="categoria in catalogo"
      :key="categoria.id"
      :categoria="categoria"
      :valores="valores"
      :erros="errosDeValidacao"
      :contagem-ativos="contagemAtivosPorCategoria[categoria.id] || 0"
      :grupo-chave="grupoChaveDaCategoria(categoria)"
      :grupo-ativo="!!gruposNecessarios[categoria.id]"
      :disabled="manipulandoDados.status || carregandoDados.status"
      @toggle-produto="onToggleProduto"
      @campo-input="onCampoInput"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BSpinner } from 'bootstrap-vue'
import AcordeaoCategoriaProduto from './AcordeaoCategoriaProduto.vue'
import { chaveDoGrupo } from '@/modules/gestaoProdutos/catalogo.mock'

export default {
  name: 'PainelGestaoProdutos',
  components: {
    AcordeaoCategoriaProduto,
    'b-spinner': BSpinner
  },
  props: {
    idEmpresa: { type: [Number, String], default: null }
  },
  computed: {
    ...mapGetters('gestaoProdutos', [
      'catalogo',
      'valores',
      'contagemAtivosPorCategoria',
      'errosDeValidacao',
      'gruposNecessarios',
      'carregandoDados',
      'manipulandoDados'
    ])
  },
  async created () {
    await this.ActionCarregarProdutos({ idEmpresa: this.idEmpresa })
  },
  methods: {
    ...mapActions('gestaoProdutos', [
      'ActionCarregarProdutos',
      'ActionDefinirProdutoAtivo',
      'ActionDefinirCampoValor'
    ]),
    grupoChaveDaCategoria (categoria) {
      return categoria.grupo ? chaveDoGrupo(categoria) : null
    },
    onToggleProduto ({ slug, ativo }) {
      this.ActionDefinirProdutoAtivo({ chave: slug, ativo })
    },
    onCampoInput ({ chave, campoChave, valor }) {
      this.ActionDefinirCampoValor({ chave, campoChave, valor })
    }
  }
}
</script>
